import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import VueMatchHeights from "vue-match-heights";
import VueComponentRegistery from "./utils/vue-component-registry";
import Vuelidate from "vuelidate";
import { Plugin } from 'vue-fragment';
import VueMask from 'v-mask'


Vue.use(Plugin);
Vue.use(VueMatchHeights);
Vue.use(Vuelidate);
Vue.use(VueMask);

import LocationSearch from './location-search/src/index.vue';
import LocationSearchStore from"./location-search/src/store";
VueComponentRegistery.register("location-search", LocationSearch, LocationSearchStore);

import LocationSearchBlock from './location-search-block/src/index.vue';
import LocationSearchBlockStore from"./location-search-block/src/store";
VueComponentRegistery.register("location-search-block", LocationSearchBlock, LocationSearchBlockStore);


import AdvisorSearch from './advisor-search/src/index.vue';
import AdvisorSearchStore from"./advisor-search/src/store";
VueComponentRegistery.register("advisor-search", AdvisorSearch, AdvisorSearchStore);

import FeaturedSearch from './featured-search/src/index.vue';
import FeaturedSearchStore from "./featured-search/src/store";
VueComponentRegistery.register("featured-search", FeaturedSearch, FeaturedSearchStore);

import CDRateCalculator from './cd-rate-calculator/src/index.vue';
import CDRateCalculatorStore from "./cd-rate-calculator/src/store";
VueComponentRegistery.register("cd-rate-calculator", CDRateCalculator, CDRateCalculatorStore);

import MortgageRateCalculator from './mortgage-rate-calculator/src/index.vue';
import MortgageRateCalculatorStore from "./mortgage-rate-calculator/src/store";
VueComponentRegistery.register("mortgage-rate-calculator", MortgageRateCalculator, MortgageRateCalculatorStore);

import MoneyMarketCalculator from './money-market-calculator/src/index.vue';
import MoneyMarketCalculatorStore from "./money-market-calculator/src/store";
VueComponentRegistery.register("money-market-calculator", MoneyMarketCalculator, MoneyMarketCalculatorStore); 


import ZipcodeIdentifier from './zipcode-identifier/src/index.vue'; 
VueComponentRegistery.register("zipcode-identifier", ZipcodeIdentifier); 


import './global/directives/clickoutside';
